import { Icon, IconName, Position } from "@blueprintjs/core"
import { get } from "lodash-es"
import React from "react"
import CustomTooltip from "./CustomTooltip"

export type StatusIconProps = {
  condition?: string
  values?: Record<string, any>
  iconSize?: number
  icon?: IconName
  children?: React.ReactNode
  className?: string
}
const StatusIcon = ({
  condition,
  values,
  iconSize = 20,
  icon = "dot",
  children,
  className,
  ...otherProps
}: StatusIconProps) => {
  const status = get(values, condition, {})
  const intent = get(status, "intent", "none")
  const statusIcon = get(status, "icon", icon)
  const statusText = get(status, "text")
  const tooltip = get(status, "tooltip")
  return (
    <span className={className}>
      {tooltip ? (
        <CustomTooltip
          content={tooltip}
          position={Position.RIGHT}
          {...otherProps}
        >
          <span>
            <Icon icon={statusIcon} intent={intent} iconSize={iconSize} />
            {statusText && <span>{statusText}</span>}
          </span>
        </CustomTooltip>
      ) : (
        <span>
          <Icon icon={statusIcon} intent={intent} iconSize={iconSize} />
          {statusText && <span>{statusText}</span>}
        </span>
      )}
    </span>
  )
}

export default StatusIcon
